/**
 * Created by zhayuechao on 2018/08/24
 * Report sharing module-api
 * @Pie 新卡续充 - 饼图
 * @Chart 新卡续充 - 趋势图
 * @Index 新卡续充 - 重要指标
 */
import axios from "./http";
import * as way from "./way";

// GET
const get = filter => {
  return axios.get("txt", {
    params: filter
  });
};

// POST
const post = params => {
  return axios.post("", params);
};

// 所有不分类下拉指标
const getSelectIndex = filter => {
  return axios.get("dropdownController/getAllIndicatorIDAndName", {
    params: filter
  });
};

// 所有分类下拉指标
const getSelectClass = filter => {
  return axios.get("dropdownController/listAllIndicatorsIDAndNameWithClass", {
    params: filter
  });
};
// 关键指标getTargetTwo
const getTarget = params => {
  return axios.post("controller/common/key/indicators", params, {
    cancelToken: way.addSource("index").token
  });
};
// 新关键指标
const getTargetTwo = params => {
  return axios.post("controller/common/list/key/indicators", params, {
    cancelToken: way.addSource("index").token
  });
};
// 一级图表
const getTable = params => {
  return axios.post("controller/common/table/data", params, {
    cancelToken: way.addSource("table").token
  });
};
// 一级图表,概况
const getTableOnes = params => {
  return axios.post("controller/common/table/generalsituation/data", params, {
    cancelToken: way.addSource("table").token
  });
};
// 一级图表,概况
const getTableOne = params => {
  return axios.post("controller/common/table/general/data", params, {
    cancelToken: way.addSource("table").token
  });
};
// 一级图表,时间、自定义
const getTableTwo = params => {
  return axios.post(
    "controller/common/table/timeOrSelfDimension/data",
    params,
    {
      cancelToken: way.addSource("table").token
    }
  );
};
// 一级图表,时间、自定义
const getTableThree = params => {
  return axios.post("controller/common/table/target/data", params, {
    cancelToken: way.addSource("table").token
  });
};
// 一级图表,同比、环比
const getTableThird = params => {
  return axios.post("controller/common/table/momOrYOYOrTarget/data", params, {
    cancelToken: way.addSource("table").token
  });
};
// 一级图表,阶梯图（会员留存）
const getRetainTable = params => {
  return axios.post("controller/common/get/ladder", params, {
    cancelToken: way.addSource("table").token
  });
};
// 二级图表
const getTwoTable = params => {
  return axios.post("controller/common/table/secondary/data", params, {
    cancelToken: way.addSource("table").token
  });
};
// 二级图表,市场
const getTwoTableTwo = params => {
  return axios.post("controller/common/table/data/secondary", params, {
    cancelToken: way.addSource("table").token
  });
};
// 获取没有维度的优惠券分析的漏斗转化表格
const getNoDimensionTable = params => {
  return axios.post("controller/common/table/no/dimension/data", params, {
    cancelToken: way.addSource("table").token
  });
};
// 获取未续充会员的表格
const getNoRechargeTable = params => {
  return axios.post("dataDetailController/no/recharge/customer", params, {
    cancelToken: way.addSource("table").token
  });
};
const getTrend = params => {
  return axios.post("controller/common/get/graph", params, {
    cancelToken: way.addSource("chart").token
  });
};
const getWordCloud = params => {
  return axios.post("/controller/common/data/wordcloud", params, {
    cancelToken: way.addSource("chart").token
  });
};
const getTrendOne = params => {
  return axios.post("controller/common/get/graph/one/dimension", params, {
    cancelToken: way.addSource("chart").token
  });
};
const getTrendTwo = params => {
  return axios.post("controller/common/get/graph/two/dimension", params, {
    cancelToken: way.addSource("chart").token
  });
};
const getTrendThird = params => {
  return axios.post("controller/common/get/graph/compare", params, {
    cancelToken: way.addSource("chart").token
  });
};

// 会员属性，多个柱状图
const getTrends = params => {
  return axios.post("controller/common/get/graph", params);
};
const getHeatmaps = params => {
  return axios.post("controller/common/thermodynamic", params, {
    cancelToken: way.addSource("chart").token
  });
};
const getSangkey = params => {
  return axios.post("controller/common/data/sankey", params, {
    cancelToken: way.addSource("chart").token
  });
};
const getFunnel = params => {
  // console.log(way.addSource("chart").token, 'token')
  return axios.post("controller/common/get/funnel/data", params, {
    //此处没有什么用处，还会影响代码的执行，直接报错，报错原因暂时未知
    // cancelToken: way.addSource("chart").token
  });
};
const getPie = params => {
  console.log(way.addSource("chart").token , 'token')
  return axios.post("controller/common/list/pieData", params, {
    cancelToken: way.addSource("pie").token
  });
};
const getPieTwo = params => {
  return axios.post("controller/common/data/list/pie", params, {
    cancelToken: way.addSource("pie").token
  });
};
// 下钻饼图，目前为饼图1 + 饼图2都显示，对比开，对比关，此时同时调用一个接口，所以不能加cancelToken
const getTwoPie = params => {
  return axios.post("controller/common/list/pieData", params, {
    // cancelToken: way.addSource('pie').token
  });
};
// 下钻饼图，市场
const getTwoPieTwo = params => {
  return axios.post("controller/common/data/list/pie", params, {
    // cancelToken: way.addSource('pie').token
  });
};

// 效率概况的面积概况
const getAreaTable = params => {
  return axios.post(
    "efficiencyAnalysisController/getTheTableDataOfAreaGeneral",
    params,
    {
      cancelToken: way.addSource("table").token
    }
  );
};
// 模糊查询理疗师
const getPer = filter => {
  return axios.get("dropdownController/listSpaTherapistInfoByContent", {
    params: filter
  });
};

// 根据门店ID查找理疗师
const getStoreIdPer = filter => {
  return axios.get("dropdownController/listSpaTherapistInfoByStoreID", {
    params: filter
  });
};

// 根据门店ID查找前台
const getReceptionistByStoreId = filter => {
  return axios.get("dropdownController/listFrontEmpByStoreID", {
    params: filter
  });
};


const getStore = (params) => {

  return axios.post("loginLogoutController/user/right/orgStores", params, {
    ContentType: "application/x-www-form-urlencoded;charset=UTF-8",
    transform: true,
  });
}
// 获取活动搜索弹窗的图表
const getActivityList = filter => {
  return axios.get("dropdownController/list/promotion/info", {
    params: filter
  });
};

//获取优惠券搜索弹窗的select下拉条件值
const getCouponSearchQuery = () => {
  return axios.get("dict/listData?dictKey=coupon_query");
};

// 获取活动搜索弹窗的图表
const getCouponList = filter => {
  return axios.get("dropdownController/list/coupon/info", {
    params: filter
  });
};

// 获取卡搜索弹窗的图表
const getCardList = filter => {
  return axios.get("dropdownController/list/card/info", {
    params: filter
  });
};
// 导入目标
const postTarget = params => {
  return axios.post("common/file/import/store/target", params, {});
};
// 获取概况的更新状态

const controllerCommonDataSyncStatus = params => {
  return axios.get("controller/common/data/sync/status", {params:params});
};

const getSynTargetData = params => {
  return axios.get("indicator/synTargetData", {params: params})
}
const getSynTargetDataV2 = params => {
  return axios.post("indicator/synTargetDataV2", params)
}
const binlogTables = params => {
  return axios.get("dropdownController/binlog/tables", {});
}

const dataDetailControllerList = params => {
  return axios.post("dataDetailController/data/sync/list", params, {});
};
// 获取区域
const getAreaList = params => {
  return axios.get("dropdownController/list/orgInfos", {params}, {});
}
// 获取集团
const getGroupList = params => {
  return axios.get("dropdownController/list/orgInfos", {params}, {});
}
// 获取公司
const getCompanyList = params => {
  return axios.get("dropdownController/list/orgInfos", {params}, {});
}

//会员信息改造获取客户指标汇总 /customer/management/metrics/summary
const getMetricsSummary = params => {
  return axios.post("v2/customer/management/metrics/summary", params, {
    cancelToken: way.addSource("index").token
  });
}
export {
  getAreaList,
  getGroupList,
  getCompanyList,
  getCardList,
  getTableOnes,
  getStore,
  get,
  post,
  getSelectIndex,
  getSelectClass,
  getPie,
  getTwoPie,
  getTarget,
  getTargetTwo,
  getTrend,
  getTrendOne,
  getTrendTwo,
  getTrendThird,
  getWordCloud,
  getTable,
  getTableOne,
  getTableTwo,
  getTableThree,
  getTableThird,
  getTwoTable,
  getHeatmaps,
  getAreaTable,
  getSangkey,
  getPer,
  getStoreIdPer,
  getTrends,
  getFunnel,
  getRetainTable,
  getActivityList,
  getCouponSearchQuery,
  getCouponList,
  getPieTwo,
  getTwoPieTwo,
  getTwoTableTwo,
  getNoDimensionTable,
  postTarget,
  getNoRechargeTable,
  getReceptionistByStoreId,
  getSynTargetData,
  controllerCommonDataSyncStatus,
  binlogTables,
  dataDetailControllerList,
  getSynTargetDataV2,
  getMetricsSummary
};
